import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import { fetchLoansLink } from '../actions';
import withOwnerTypeAndId from '../../common/hoc/withOwnerTypeAndId';
import openLinkInNewWindow from '../../common/helpers/openLinkInNewWindow';
import { setFrontendFlags } from '../../auth/actions';

export default compose(
  withOwnerTypeAndId,
  connect(null, { fetchLoansLink, setFrontendFlags }),
  withHandlers({
    onLearnMoreClicked: props => () => {
      props.setFrontendFlags({ stripeNoOfferPageViewed: true });

      props.fetchLoansLink(props.ownerId, props.ownerType, 'capital_financing_offer')
        .then(({ url }) => openLinkInNewWindow(url));
    },
  }),
);
